import React, { Component, ChangeEvent } from 'react';
import './styles.scss';

export interface Props {
  label: string;
  isChecked: boolean;
  onChange: (arg: boolean | ChangeEvent<HTMLInputElement>) => void;
  name: string;
  error: boolean;
  modal?: () => void;
}

class Checkbox extends Component<Props> {
  render() {
    const { label, isChecked, onChange, name, error } = this.props;
    return (
      <div className={`checkbox__input ${error ? 'checkbox__input--error' : ''}`}>
        <input
          className="checkbox__input__field type__input__field"
          tabIndex={0}
          type="checkbox"
          name={name}
          checked={isChecked}
          onChange={onChange}
          onKeyDown={event => this._handleKeySubmit(event.keyCode)}
          id={label}
        />
        <label htmlFor={label} className="checkbox__input__label type__input__label">
          {label}
          {this.props.modal ? (
            <React.Fragment>
              <span className="modal__control type__link" onClick={this.props.modal}>
                Learn more
              </span>
              <span>.</span>
            </React.Fragment>
          ) : null}
        </label>
      </div>
    );
  }

  // Custom Methods ---------------------------------------------
  _handleKeySubmit(key: number) {
    if (key === 13 || key === 16) {
      this.props.onChange(!this.props.isChecked);
    }
  }
}

export default Checkbox;
